import React from "react";
import { Box, useTheme } from "@mui/material";

export default function DefaultBlock({ children, text, width = "1400px" }) {
  const theme = useTheme();

  return (
    <Box
      className="backgroundLines"
      width="100%"
      sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
    >
      <Box
        sx={{
          position: "relative",
          maxWidth: width,
          margin: "0 auto",
          backgroundColor: theme.palette.background.default,
          borderLeft: `1px solid ${theme.palette.divider}`,
          borderRight: `1px solid ${theme.palette.divider}`,
          minHeight: 64,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
